const CHANNEL_LABELS = { email: "Email", phone: "Phone" };

const CHANNEL_ORDER = ["email", "phone"];

export const EMPTY_CODES = { email: "", phone: "" };

const maskedFor = (channel, dto) =>
  (channel === "email" ? dto?.maskedEmail : dto?.maskedPhone) ?? null;

export const toOtpChallenge = (dto) => {
  const returned = Array.isArray(dto?.channels) ? dto.channels : [];

  const targets = CHANNEL_ORDER.filter((channel) =>
    returned.includes(channel)
  ).map((channel) => ({
    channel,
    masked: maskedFor(channel, dto),
    label: CHANNEL_LABELS[channel],
  }));

  return {
    sessionId: dto?.sessionId ?? null,
    targets,
    message: dto?.message?.trim() || null,
    hasTargets: targets.length > 0,
  };
};

export const toConfirmPayload = (sessionId, targets, codes) => {
  const payload = { sessionId };

  targets.forEach((target) => {
    if (target.channel === "email") payload.otpEmail = codes.email;
    if (target.channel === "phone") payload.otpPhone = codes.phone;
  });

  return payload;
};

export const isChallengeComplete = (targets, codes, length) =>
  targets.length > 0 &&
  targets.every((target) => (codes[target.channel] || "").length === length);

export const targetSummary = (targets) => {
  const parts = targets.map((target) => target.masked).filter(Boolean);

  if (!parts.length) return "";
  if (parts.length === 1) return parts[0];

  return `${parts.slice(0, -1).join(", ")} and ${parts[parts.length - 1]}`;
};
